module.exports = __webpack_public_path__ + "static/media/searchIconWhite.525dbeed.svg";